<template>
<v-data-table
    v-model="selected"
    :headers="headers"
    :items="gastos"
     :search="search"
     item-key="id"
    sort-by="fecha"
    show-select
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title style="color:#1C2546;margin-top:40px">Grupos de gastos pendientes de envío</v-toolbar-title>
        <v-divider class="mx-4" inset vertical style="margin-top:30px"></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog"  max-width="1280"  >  
          <v-card>
            <v-card-title>
              <span class="headline">Detalle de grupo de gastos</span>
            </v-card-title>

            <v-card-text >
              <v-container >
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.nombre" label="Nombre" value="editedItem.nombre"></v-text-field>
                  </v-col>
                   <v-col cols="12" sm="6" md="8">
                    <v-text-field v-model="editedItem.descripcion" label="Descripción" value="editedItem.descripcion"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="12">
                   <div class="text-right">
                    <v-btn class="ma-2" tile color="primary" dark @click="dialogAddGrupo = true">Desagrupar</v-btn>
                  </div>
                    <v-card-title>
                      Solicitudes del grupo de gastos
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Buscar"

                        hide-details
                      ></v-text-field>
                    </v-card-title>
                         <v-data-table
                          v-model="selectedSol"
                          :headers="headerSolicitudG"
                          :items="solicitudesG"
                          :search="search"
                          item-key="id_solicitud"
                          show-select
                          class="elevation-1"
                        >
                        <template v-slot:item.actions="{ item }">
                          <!--<v-icon
                            small
                            class="mr-2"
                            @click="editItem(item)"
                          >
                            mdi-pencil
                          </v-icon>-->
                          <v-icon
                            small
                            @click="deleteItem2(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Actualizar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row justify="center">
        <v-dialog v-model="dialogD"  max-width="590">
          <v-card>
            <v-card-title class="headline"> Eliminar grupo de gastos </v-card-title>
            <v-card-text>
            ¿ Estás seguro de eliminar el grupo de gastos ?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogD = false">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="borrar">Confirmar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        </v-row>
       <v-row justify="center">
        <v-dialog v-model="dialogD2"  max-width="590">
          <v-card>
            <v-card-title class="headline"> Eliminar solicitud de gastos </v-card-title>
            <v-card-text>
            ¿ Estás seguro de eliminar la solicitud de gastos ?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogD2 = false">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="borrar2">Confirmar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        </v-row>
        <v-row justify="center">
              <v-dialog v-model="dialogEnvio"  max-width="590">
                <v-card>
                  <v-card-title class="headline"> Enviar grupos de comprobantes </v-card-title>
                  <v-card-text>
                  ¿ Estás seguro de enviar los grupos de comprobantes a autorización ?
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogEnvio = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="EnviarAll">Confirmar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
        </v-row>
         <v-row justify="center">
              <v-dialog v-model="dialogAddGrupo" max-width="590">
                <v-card>
                  <v-card-title class="headline"> Desagrupar solicitudes </v-card-title>
                  <v-card-text>
                     ¿ Estás seguro de desagrupar las solicitudes seleccionadas ?
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogAddGrupo = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="DesaAgregarG">Confirmar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
        </v-row>
      </v-toolbar>
      <div class="text-right" style="margin-top:35px">
        <!--<v-btn class="ma-2" tile color="primary" dark @click="dialogAddGrupo = true">Agregar a grupo</v-btn>-->
        <v-btn class="ma-2" tile color="primary" dark @click="dialogEnvio = true">
          <v-icon left>mdi-send</v-icon> Enviar
        </v-btn>
      </div>
        <v-alert type="success" :value='alert' close-text="Cerrar" dismissible style="margin-top:40px">
              Grupo de gastos editado con exito.
             
        </v-alert>
         <v-alert type="success" :value='alert2' close-text="Cerrar" dismissible style="margin-top:40px">
              Grupo de gastos borrado correctamente
        </v-alert>
        <v-alert type="success" :value='alert3' close-text="Cerrar" dismissible style="margin-top:40px">
              Se enviaron los grupos de gastos a autorización.
              
        </v-alert>
        <v-alert type="success" :value='alert4' close-text="Cerrar" dismissible style="margin-top:40px">
             Solicitud de gasto borrado correctamente
              
        </v-alert>
         <v-alert type="success" :value='alert5' close-text="Cerrar" dismissible style="margin-top:40px">
            Se desagrupo exitosamente las solicitudes seleccionadas.
              
        </v-alert>


        <v-card-title style="margin-top40px"> 
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
    </template>

     
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import axios from "axios";
import router from '../router/index.js'

export default {
  name: "SolicitudComprobacion",
    data: () => ({
      search: '',
      menu2: false,
      dialog: false,
      dialogD: false,
      dialogD2:false,
      dialogAddGrupo: false,
      dialogEnvio: false,
      alert: false,
      alert2: false,
      alert3: false,
      alert4: false,
      alert5: false,
      alertMsg:'',
      selected: [],
      selectedSol:[],
      headers: [
        { text: "Fecha de creación", value: "fecha_creacion", sortable: true },
        { text: "Grupo", align: "left", sortable: true, value: "nombre" },
        { text: "Descripcion", value: "descripcion", sortable: true },
        { text: "Usuario última modificación", value: "usuario_ultima_modificacion" },
        { text: "Fecha de modificación", value: "fecha_modificacion" },
        { text: "Acciones", value: "actions", sortable: false }
    ],
    headerSolicitudG: [
        { text: "Fecha de Comprobacion", value: "fecha_comprobacion", sortable: true },
        { text: "Deudor", align: "left", sortable: true, value: "deudor" },
        { text: "Concepto", value: "concepto" },
        { text: "Importe", value: "importe" },
        { text: "Cuenta", value: "cuenta" },
        { text: "Tipo", value: "tipo", sortable: true },
        { text: "Descripcion", value: "descripcion", sortable: true },
        { text: "Acciones", value: "actions", sortable: false }
    ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
      id: "",
      id_solicitud: "",
      IdSolicitud:'',
      nombre:"",
      Deudor: "",
      idconcepto: "",
      Estado: "",
      Tipo: "",
      Cuenta: "",
      idcuenta:"",
      importe: "",
      descripcion: "",
      FechaComprobacion: ""
    },
    defaultItem: {
      id: "",
       nombre:"",
      idconcepto: "",
      Estado: "",
      Tipo: "",
       Cuenta: "",
      importe: "",
      descripcion: "",
      FechaComprobacion: ""
    },
     gastos: [],
    
    cuentas: [       
        {cuenta :"625720 GASTOS NO DEDUCIBLES", idcuenta:"1"},
        {cuenta :"625110 VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"2"},
        {cuenta :"625110 VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"3"},
        {cuenta :"625720 GASTOS NO DEDUCIBLES", idcuenta:"4"},
        {cuenta :"613620 ALQUILER TRANSPORTES", idcuenta:"5"},
        {cuenta :"613621 ALQUILER TRANSPORTES ND", idcuenta:"6"},
        {cuenta :"625110 VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"7"},
        {cuenta :"625720 GASTOS NO DEDUCIBLES", idcuenta:"8"},
        {cuenta :"606110 GASOLINA", idcuenta:"9"},
        {cuenta :"606111 GASOLINA ND", idcuenta:"10"},
        {cuenta :"625120 REEMBOLSO Y GASTOS VEHICULOS", idcuenta:"11"},
        {cuenta :"625110 VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"12"},
        {cuenta :"625720 GASTOS NO DEDUCIBLES", idcuenta:"13"},
        {cuenta :"625110 VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"14"},
        {cuenta :"625720 GASTOS NO DEDUCIBLES", idcuenta:"15"},
        {cuenta :"625110 VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"16"},
        {cuenta :"625720 GASTOS NO DEDUCIBLES", idcuenta:"17"},
        {cuenta :"613201 GASTOS COMUNES", idcuenta:"18"},
        {cuenta :"613202 GASTOS COMUNES ND", idcuenta:"19"},
        {cuenta :"613201 GASTOS COMUNES", idcuenta:"20"},
        {cuenta :"613202 GASTOS COMUNES ND", idcuenta:"21"},
        {cuenta :"606400 GASTOS DE LIBRERIA", idcuenta:"22"},
        {cuenta :"606300 GASTOS DE LIMPIEZA", idcuenta:"23"},
        {cuenta :"626400 MESSENGER SERVICES", idcuenta:"24"},
        {cuenta :"623400 CUSTOMER GIFTS", idcuenta:"25"},
        {cuenta :"625700 MEALS & ENTERTAINMENT", idcuenta:"26"},
        {cuenta :"615610 MANTENIMIENTO VEHICULO", idcuenta:"27"},
        {cuenta :"615600 MANTENIM DE MAT INFORMATICO", idcuenta:"28"},
    ],
    postBody: "",
    errors: [],
    grupos: [],
    grupoSelected: "",
    idGrupo: null,
    gruposAll: [],
    tipo: ["Comprobacion", "Anticipo"],
    estado: ["Pendiente", "Actualizado", "Cancelado"],
    solicitudes: [],
    solicitudesG:[],
    arr: [],
    nombres: []
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Actualizar solicitud'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },
    mounted() {
     //Config for axios
      axios.defaults.headers.common['access-token'] = this.$store.state.token;

      axios.interceptors.response.use(function (response){
          //console.log(response.data.message);
          if (response.data.message == 'Token inválida') {
              router.push({name: 'login', params: {errorToken: 'true'}});
          }else{
              return response;
          }
      });
      //End config for axios
     this.Dates();
     this.getGasto();
     this.getCuenta();
     this.getGrupos();
  },
    methods: {
     getSolicitudes() {
      axios.get("https://"+process.env.VUE_APP_URL+":3000/solicitud").then(res =>{
        this.solicitudes = res.data;
      });
    },
     getGrupos() {
     let status='4';
      axios.get("https://"+process.env.VUE_APP_URL+":3000/grupos/"+status).then(res =>{
        //console.log(res.data);
        this.gastos= res.data;
      });
    },
    getSolicitudeGrupo() {
     let idGrupo = this.editedItem.id;
     //alert('Hola grupo'+idGrupo);
      axios.get("https://"+process.env.VUE_APP_URL+":3000/solicitudGrupo/"+idGrupo).then(res=>{
        //console.log(res.data);
        this.solicitudesG= res.data;
      });
    },
      getCuenta() {
      var idg = this.editedItem.idconcepto;
      axios.get("https://"+process.env.VUE_APP_URL+":3000/cuentasgastos/" + idg).then(res=>{
       /* var tam = res.data.length;
        var idc = "";
        var desc = "";
        var name = "";
        var arr = [];

        for (var i = 0; i < tam; i++) {
          idc = res.data[i].id_cuenta;
          desc = res.data[i].descripcion;
          name = idc + " " + desc;
          arr.push(name);
        }*/
        this.cuentas = res.data;
      });
    },
  getGasto() {
       
      axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos").then(res=>{
        //console.log(res.data);
        this.gastos = res.data;
      });
    },
    editItem (item) {
      /*
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.getSolicitudeGrupo();
      this.dialog = true
      */
      this.$router.push({ name: 'EditarGrupoComprobacion', params: {item: item}});
    },

      deleteItem (item) {
        //const index = this.desserts.indexOf(item)
         this.editedIndex = this.desserts.indexOf(item)
         this.editedItem = Object.assign({}, item)
         this.dialogD = true
        //confirm('Estas seguro de eliminas esta solicitud?') && this.desserts.splice(index, 1)
      },
       deleteItem2 (item) {
        //const index = this.desserts.indexOf(item)
         this.editedIndex = this.desserts.indexOf(item)
         this.editedItem = Object.assign({}, item)
         //alert('Datos item '+this.editedItem.id+'-'+this.editedItem.id_solicitud+'-'+this.editedItem.Idsolicitud);
         this.dialogD2 = true
        //confirm('Estas seguro de eliminas esta solicitud?') && this.desserts.splice(index, 1)
      },
 Dates() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      today = yyyy + "-" + mm + "-" + dd;
    },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        let igrupo = this.editedItem.id;
        let nombre = this.editedItem.nombre;
        let descripcion = this.editedItem.descripcion;
      var c = {
        id: igrupo,
        nombre: nombre,
        descripcion: descripcion
      };
      axios.put("https://"+process.env.VUE_APP_URL+":3000/grupos/edit", c).then(function(){
        //console.log(res.data);
        //this.gastos = res.data;
        this.alert=true;
        this.getGrupos();
        this.close()
      });
      },
      borrar () {
       this.dialogD = false
       let Idgrupo= this.editedItem.id;
       axios.delete("https://"+process.env.VUE_APP_URL+":3000/Deletegrupo/"+Idgrupo).then(function(){
         //console.log(res.data);
         this.alert2=true;
         this.getGrupos();
         this.close()
      });
      },
       borrar2 () {
       this.dialogD2 = false
       let Idsolicitud= this.editedItem.id_solicitud;
       axios.delete("https://"+process.env.VUE_APP_URL+":3000/Deletesolicitud/"+Idsolicitud).then(function(){
         //console.log(res.data);
         this.alert4=true;
         this.getSolicitudeGrupo();
         this.close()
      });
      },
      DesaAgregarG () {
      this.dialogAddGrupo = false
        //alert('Agrega las solicitudes a grupo de gasto'+this.selected);
        //let idsSolicitudes="'";
        let solicitudes=this.selectedSol;
        /*for(var x=0;x<solicitudes.length;x++){
            if(x<(solicitudes.length)-1)idsSolicitudes+=solicitudes[x].IdSolicitud+'/';
            else idsSolicitudes+=solicitudes[x].IdSolicitud+'|';
        }
        idsSolicitudes=idsSolicitudes.replace("/","','");
        idsSolicitudes=idsSolicitudes.replace("|","'");*/
         var c = {
            solicitudes: solicitudes,
          };
          axios.put("https://"+process.env.VUE_APP_URL+":3000/DesGruposolicitud", c).then(res=>{
            //console.log(res.data);
            this.alertMsg=res.data.message;
            this.alert5=true;
            this.getSolicitudeGrupo();

            this.close()
          });
      },
      EnviarAll() {
        this.dialogEnvio = false;
       // let idsGrupos="'";
        let grupos=this.selected;
       /* for(var x=0;x<grupos.length;x++){
            if(x<(grupos.length)-1)idsGrupos+=grupos[x].id+'/';
            else idsGrupos+=grupos[x].id+'|';
        }
        idsGrupos=idsGrupos.replace("/","','");
        idsGrupos=idsGrupos.replace("|","'");*/
         var c = {
            grupos: grupos,
          };
          axios.put("https://"+process.env.VUE_APP_URL+":3000/enviaAutorizaG", c).then(res=>{
            //console.log(res.data);
            this.alertMsg=res.data.message;
            this.alert3=true;
            this.getGrupos();
            this.close()
          });
      },
    },
  }
</script>